import { render, staticRenderFns } from "./apppermissions.vue?vue&type=template&id=5e08e0ec&scoped=true&"
import script from "./apppermissions.vue?vue&type=script&lang=ts&"
export * from "./apppermissions.vue?vue&type=script&lang=ts&"
import style0 from "./apppermissions.vue?vue&type=style&index=0&id=5e08e0ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e08e0ec",
  null
  
)

export default component.exports